var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "relative max-w-10xl mx-auto mt-3 lg_mt-4 xl_mt-5" },
    [
      ["sm", "md"].includes(_vm.$mq)
        ? _c("responsive-image", {
            staticClass: "md_hidden",
            attrs: {
              sizes: "(min-width: 769px) 0px, 100vw",
              "image-object": _vm.bannerMobileImg,
              "alt-text": "Planning to sell your designs on ViralStyle?"
            }
          })
        : _c("responsive-image", {
            staticClass: "hidden md_block",
            attrs: {
              sizes: "(min-width: 768px) 100vw, 0px",
              "image-object": _vm.bannerImg,
              "alt-text": "Planning to sell your designs on ViralStyle?"
            }
          }),
      _c(
        "div",
        {
          staticClass:
            "absolute absolute--center flex justify-center items-center px-1 flex-wrap text-center w-full"
        },
        [
          _c(
            "div",
            {
              staticClass:
                "text-4xl md_text-xl text-white font-bold tracking-wide px-1 md_p-0 md_mr-2 my-1 lg_mr-3"
            },
            [_vm._v("Planning to sell your designs on ViralStyle?")]
          ),
          _c("buyer-button", {
            staticClass: "mr-2 my-1 lg_mr-3",
            attrs: { text: "JOIN NOW" },
            nativeOn: {
              click: function($event) {
                return _vm.$router.push({ name: "signUp" })
              },
              keyup: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.$router.push({ name: "signUp" })
              }
            }
          }),
          _c("link-button", {
            staticClass: "my-1",
            attrs: { text: "HOW IT WORKS" },
            on: {
              click: function($event) {
                return _vm.$router.push({ name: "openShop" })
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }